import styled from 'styled-components'

import { ExploreDevTokensTooltip } from '@root/features/explore/ui/explore-dev-tooltip/explore-dev-tokens-tooltip'
import { CountMax3DigitsFormatted } from '@root/shared/core/format'
import {
  CrownOutlinedIcon,
  TooltipCard,
  TooltipCardParentGuardProvider,
} from '@root/shared/ui-kit'

import { usePairDevTokensInfo } from '../../hooks/use-pair-dev-tokens-info'

import type { PairModel } from '../../atoms'

type Props = {
  pair: PairModel
  onClick?: () => void
}

export const PairInformationDevTokens: React.FC<Props> = ({
  pair,
  onClick,
}) => {
  const devTokensInfo = usePairDevTokensInfo(pair)

  if (!devTokensInfo) {
    return undefined
  }

  return (
    <TooltipCardParentGuardProvider withCascadePreviews>
      <TooltipCard
        closeArea={
          <ExploreDevTokensTooltip.CloseArea devTokensInfo={devTokensInfo} />
        }
        clickArea={
          <ExploreDevTokensTooltip.ClickArea devTokensInfo={devTokensInfo} />
        }
      >
        <Root
          onClick={onClick}
          data-has-click={onClick !== undefined}
          data-has-migrated={devTokensInfo.bondedTokensWithoutCurrent > 0}
        >
          <CrownOutlinedIcon size={16} />
          <span>
            {devTokensInfo.bondedTokensWithoutCurrent}/
            <CountMax3DigitsFormatted
              count={devTokensInfo.totalPoolsWithoutCurrent}
            />
          </span>
        </Root>
      </TooltipCard>
    </TooltipCardParentGuardProvider>
  )
}

const Root = styled.div`
  pointer-events: auto;
  display: grid;
  grid-auto-flow: column;
  gap: 2px;
  align-items: center;

  &[data-has-click='true'] {
    cursor: pointer;
  }

  &[data-has-migrated='true'] {
    color: var(--amber-9);
  }
  &[data-has-migrated='false'] {
    color: var(--text-11);
  }

  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
`
